import { Controller } from "@hotwired/stimulus"

export default class MessageTypesController extends Controller {
  static targets = ["checkbox"]

  declare checkboxTargets: HTMLInputElement[]

  connect() {
    this.dispatchSelectionChanged()
  }

  selectionChanged() {
    this.dispatchSelectionChanged()
  }

  private dispatchSelectionChanged() {
    const hasSelection = this.checkboxTargets.some(cb => cb.checked && !cb.disabled)
    this.dispatch("selectionChanged", {
      detail: { hasSelection },
      prefix: "compose"
    })
  }
}
